import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "NotificationOff"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.74992 17.25V16.05L5.77492 14.025C5.92306 13.8913 6.00527 13.6995 5.99992 13.5V9.75C6.00136 7.44382 7.32446 5.34256 9.40353 4.34461C11.4826 3.34665 13.9497 3.62864 15.7499 5.07L16.8299 3.9975C15.6828 3.00805 14.2576 2.39765 12.7499 2.25V0.75H11.2499V2.25C7.42825 2.68567 4.53201 5.90371 4.49992 9.75V13.2L2.47492 15.225C2.32677 15.3587 2.24456 15.5505 2.24992 15.75V17.25H3.74992ZM19.5 13.2V9.75C19.4953 8.57654 19.2153 7.42055 18.6825 6.375L22.5 2.5575L21.4425 1.5L1.5 21.4425L2.5575 22.5L6.3075 18.75H8.25C8.25 20.8211 9.92893 22.5 12 22.5C14.0711 22.5 15.75 20.8211 15.75 18.75H21C21.2027 18.7634 21.4014 18.6887 21.545 18.545C21.6887 18.4014 21.7634 18.2027 21.75 18V15.75C21.7554 15.5505 21.6731 15.3587 21.525 15.225L19.5 13.2ZM12 21C10.7574 21 9.75 19.9926 9.75 18.75H14.25C14.25 19.9926 13.2426 21 12 21ZM20.25 17.25H7.81502L17.565 7.5C17.8522 8.2154 17.9998 8.97912 18 9.75V13.5C17.9947 13.6995 18.0769 13.8913 18.225 14.025L20.25 16.05V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/NotificationOff.vue"]]);
